import {
  BrowserRouter as Router,
  Route, Routes
} from 'react-router-dom';

import './App.css';
import Home from './containers/Home';
import React from 'react';
import Search from './containers/Search';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/search" element={<Search />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
